import { Component, Output, EventEmitter, Inject, OnInit, ChangeDetectionStrategy, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { Subject } from 'rxjs';
import { AddOwnTemplateDialogComponent } from '../../add-own-template-dialog/add-own-template-dialog.component';
import { QnSbnDataService } from '../../../services/qn-sbn-data-service.service';

@Component({
  selector: 'dl-msg-attachment-template-dialog',
  templateUrl: './message-attachment-template-dialog.component.html',
  styleUrls: ['./message-attachment-template-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageAttachmentTemplateDialogComponent implements OnInit {
  // MessageAttachmentTemplateComponent
  public templateColumn: any;
  public templateData: any;
  public newMessageTemplate: Subject<any> = new Subject<any>();
  public isAffBtnDisabled = true;
  public isNtBtnDisabled = false;
  public isNewFromTemplate = true;
  public selectedRow = [];
  public constructor(private readonly dialog: MatDialog, public dialogRef: MatDialogRef<MessageAttachmentTemplateDialogComponent>, private changeDetectorRef: ChangeDetectorRef, private _QnSbnDataService: QnSbnDataService, @Inject(MAT_DIALOG_DATA) public data: any, private readonly oneSnackBar?: OneSnackBarService) { }

  public ngOnInit(): void {
    this.templateColumn = this.data.columnData;
    this.templateData = this.data.tableData;
  }

  public addTemplateToForm(): void {
    const newData = {
      newColumnData: ['dragHandle', 'selectText', 'messageTemplate', 'iconSets'],
      newTableData: this.selectedRow
    };
    this.dialogRef.close({ data: newData });
    this._QnSbnDataService.getMappedQnsbnData({
      "subjectName": this.selectedRow[0].templateDetails.templateSubject,
      "messageAttachmentRTEText": this.selectedRow[0].templateDetails.templateBody,
      "templateId": this.selectedRow[0].templateId || ""
    }, "MessageAttachment");
  }

  public getSelectedRowInTemplate(rows: any): void {
    this.selectedRow = rows.messageSelected;
    const isSelected = this.selectedRow.length > 0;
    this.isAffBtnDisabled = !isSelected;
    this.isNtBtnDisabled = isSelected;
  }

  public openNewTemplateAction(): void {
    const dialogRef = this.dialog.open(AddOwnTemplateDialogComponent, {
      data: { tableData: [], columnData: [], allTemplates: this.templateData, messageType: 'Email' },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(newEntry => {
      if (newEntry.data) {
        this.templateData = newEntry.data;
        // this.templateData = [{
        //   "templateDetails": newEntry.data,
        //   "templateId": newEntry.data.templateId
        // }];
        const newMsgTemplateSource = {
          templateData: newEntry.data, // this.templateData,
          placement: 'before'
        };
        this.newMessageTemplate.next(newMsgTemplateSource);
        this.changeDetectorRef.detectChanges();
      }
    });
  }
}
